const ne = {
  meta: { code: "ne", label: "नेपाली" },
  nav: {
    brand: "IQ Log",
    diagnostics: "मूल्याङ्कन",
    mypage: "मेरो पृष्ठ",
    login: "लग इन",
    register: "दर्ता",
    logout: "लग आउट",
  },
  hero: {
    eyebrow: "मूल्याङ्कन प्लेटफर्म",
    title: "मूल्याङ्कनबाट आफ्नो सार पत्ता लगाउनुहोस्",
    subtitle1: "सोच, व्यक्तित्व र प्रतिभा — पूर्ण रूपमा देखिने",
    subtitle2: "५ मिनेटमा आफ्ना बल र कमजोरी हेर्नुहोस्",
    subtitle3: "हरेक मूल्याङ्कन तपाईंको डेटा बन्छ",
    cta_primary: "मूल्याङ्कन सुरु गर्नुहोस्",
    cta_secondary: "क्याटलग हेर्नुहोस्",
    disclaimer: "सन्दर्भ जानकारी / गैर-चिकित्सा",
  },
  categories: {
    ability: "क्षमता",
    personality: "व्यक्तित्व",
    mental: "मानसिक",
    aptitude: "प्रतिभा",
    traits: "गुणहरू",
  },
  catalog: {
    title: "सबै मूल्याङ्कन",
    subtitle: "१७ परीक्षा / ५ वर्ग",
    filter_all: "सबै",
    duration: "मिनेट",
    difficulty: { easy: "सजिलो", medium: "मध्यम", hard: "कठिन" },
    question_count: "प्रश्न",
    start: "सुरु",
  },
  quiz: {
    question: "प्रश्न",
    of: "/",
    next: "अर्को",
    prev: "पछाडि",
    submit: "नतिजा हेर्नुहोस्",
    progress: "प्रगति",
    exit: "बाहिर",
    required: "एउटा विकल्प छान्नुहोस्",
    submitting: "स्कोरिङ…",
  },
  result: {
    overall: "कुल स्कोर",
    type_label: "प्रकार",
    share_link: "लिङ्कमार्फत साझा गर्नुहोस्",
    back_to_catalog: "अर्को मूल्याङ्कन लिनुहोस्",
    view_mypage: "मेरो पृष्ठमा इतिहास हेर्नुहोस्",
    premium_title: "विस्तृत विश्लेषण अनलक गर्नुहोस्",
    premium_subtitle: "प्रिमियमसँग, तपाईंले तलका सबै देख्नुहुनेछ:",
    feature_breakdown: "विस्तृत स्कोर ब्रेकडाउन",
    feature_cause: "मूल कारण विश्लेषण",
    feature_plan: "सुधार योजना",
    feature_pdf: "PDF रिपोर्ट (A4)",
    price: "¥980",
    price_note: "(Stripe मार्फत सुरक्षित भुक्तानी)",
    price_free: "नि:शुल्क",
    price_free_note: "(सीमित समय · १००% नि:शुल्क)",
    unlock_button: "Stripe मा भुक्तानी",
    unlock_button_free: "नि:शुल्क अनलक",
    unlock_requires_auth: "अनलक गर्न साइन इन गर्नुहोस्",
    unlock_save_first: "पहिले खातासँग नतिजा बचत गर्नुहोस्",
    unlocking: "Stripe मा रिडाइरेक्ट हुँदै…",
    free_only_notice: "नि:शुल्क संस्करणले कुल स्कोर र प्रकार मात्र देखाउँछ।",
    compliance_note:
      "यो मूल्याङ्कन सन्दर्भ जानकारी मात्र हो र चिकित्सा निदान होइन। हामी निश्चयात्मक वा डर बढाउने भाषा प्रयोग गर्दैनौं।",
  },
  premium: {
    title: "विस्तृत विश्लेषण रिपोर्ट",
    summary: "समग्र सारांश",
    strengths: "बल",
    weaknesses: "विकास क्षेत्र",
    improvements: "सुधार योजना",
    dimensions: "आयामी स्कोर",
    download_pdf: "PDF डाउनलोड",
    pdf_soon: "PDF निर्यात (छिट्टै)",
  },
  mypage: {
    title: "मेरो पृष्ठ",
    subtitle: "तपाईंको इतिहास, स्कोर प्रवृत्ति, र ब्याजहरू",
    total: "कुल मूल्याङ्कन",
    average: "औसत स्कोर",
    premium_count: "अनलक भएको",
    categories_covered: "समेटिएका वर्गहरू",
    trend_title: "स्कोर प्रवृत्ति",
    history_title: "इतिहास",
    badges_title: "ब्याजहरू",
    unlock_3_title: "समग्र विश्लेषण अनलक",
    unlock_3_desc: "थप {n} मूल्याङ्कन गर्नुहोस् समग्र विश्लेषण अनलक गर्न",
    unlocked: "समग्र विश्लेषण अनलक भयो",
    no_history: "अहिलेसम्म मूल्याङ्कन छैन — पहिलो थाल्नुहोस्।",
  },
  auth: {
    login_title: "लग इन",
    register_title: "खाता बनाउनुहोस्",
    email: "इमेल",
    password: "पासवर्ड (कम्तीमा ६ अक्षर)",
    name: "प्रदर्शन नाम (वैकल्पिक)",
    login_btn: "लग इन",
    register_btn: "साइन अप",
    go_register: "खाता छैन? साइन अप",
    go_login: "खाता छ? लग इन",
    anon_note: "मूल्याङ्कन नि:शुल्क र गुमनाम छ। नतिजा बचत र प्रिमियमका लागि मात्र खाता आवश्यक हुन्छ।",
    success_register: "खाता बनाइयो",
    success_login: "साइन इन भयो",
    consent_section: "सहमति",
    consent_required: "आवश्यक वस्तुहरू स्वीकार गर्नुहोस्",
    accept_terms_pre: "म सहमत छु",
    terms_link: "सेवाका सर्तहरू",
    accept_terms_post: "",
    accept_privacy_pre: "मैले पढेँ",
    privacy_link: "गोपनीयता नीति",
    accept_privacy_post: "र मेरो व्यक्तिगत डेटा प्रशोधनलाई सहमति दिन्छु",
    accept_age: "म १६ वर्ष वा माथि छु (वा संरक्षकको सहमति छ)",
    accept_marketing: "नयाँ मूल्याङ्कन र प्रोमोको इमेल पठाउनुहोस्",
    optional: "वैकल्पिक",
  },
  landing: {
    status_online: "सिस्टम अनलाइन",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "१७ परीक्षण",
    status_langs: "१४ भाषा",
    status_ai: "AI · सक्रिय",
    title_line1: "आफ्नो सार पत्ता लगाउनुहोस्",
    title_line2: "५ मिनेटमा।",
    trust_diagnostics: "मूल्याङ्कन",
    trust_languages: "भाषा",
    trust_per_test: "प्रति परीक्षण",
    hud_readout: "प्रमुख रिडआउट",
    hud_score_unit: "/100 कुल",
    hud_band: "बैन्ड · GOLD",
    hud_dimensions: "आयाम",
    hud_dimensions_status: "३ / ३ सक्रिय",
    hud_syslog: "सिस्टम लग",
    cat_eyebrow: "// वर्ग",
    cat_title_pre: "५ वर्ग · ",
    cat_title_highlight: "१७ मूल्याङ्कन",
    view_all: "सबै हेर्नुहोस्",
    proto_eyebrow: "// प्रक्रिया",
    proto_title_pre: "३ चरणमा ",
    proto_title_highlight: "सार खोल्नुहोस्।",
    step1_title: "परीक्षण छान्नुहोस्",
    step1_body: "१७ बाट छान्नुहोस्। गुमनाम सुरुवात।",
    step2_title: "५ मिनेटमा उत्तर",
    step2_body: "प्रगति बार र ब्याजले प्रेरणा दिन्छ।",
    step3_title: "AI ले अनलक",
    step3_body: "विस्तृत स्कोर, योजना र PDF।",
    final_eyebrow: "// तयार?",
    final_title_pre: "तपाईंको सार ",
    final_title_highlight: "५ मिनेटमा।",
    final_subtitle: "५ मिनेटमा आफ्ना बल र कमजोरी हेर्नुहोस्",
    final_button: "अहिले मूल्याङ्कन सुरु",
  },
  footer: {
    tagline: "सोच, व्यक्तित्व र प्रतिभाको मूल्याङ्कन प्लेटफर्म",
    rights: "सबै अधिकार सुरक्षित।",
    legal: "कानूनी",
    privacy: "गोपनीयता",
    terms: "सर्तहरू",
    about_label: "हाम्रो बारेमा / कम्पनी",
    compliance_label: "अन्तर्राष्ट्रिय अनुपालन",
    tokushoho_label: "जापान वाणिज्य ऐन प्रकटीकरण",
    data_protection_label: "डेटा सुरक्षा (अन्तर्राष्ट्रिय)",
    data_request_label: "डेटा मेटाउने / अप्ट-आउट",
    disclaimer_label: "अस्वीकरण",
    disclaimer_full:
      "यो सेवा सन्दर्भ मात्र हो र चिकित्सा निदान होइन। हामी निश्चयात्मक वा डर बढाउने भाषा प्रयोग गर्दैनौं।",
  },
  badges: {
    "first-diagnosis": "पहिलो मूल्याङ्कन",
    "three-diagnostics": "३ मूल्याङ्कन",
    "five-diagnostics": "५ मूल्याङ्कन",
    "ten-diagnostics": "१० मूल्याङ्कन",
    "high-performer": "उच्च प्रदर्शन",
    "premium-user": "प्रिमियम प्रयोगकर्ता",
  },
  lang_selector: "भाषा",
  payment: {
    processing_title: "भुक्तानी प्रमाणीकरण…",
    processing_subtitle: "Stripe बाट फर्केको — विस्तृत विश्लेषण बनाउँदै (२० सेकेन्डसम्म)",
    success: "भुक्तानी पुष्टि भयो — प्रिमियम अनलक",
    expired: "चेकआउट सेसन समाप्त भयो। पुनः प्रयास गर्नुहोस्।",
    error: "भुक्तानी प्रमाणीकरण असफल। समर्थनलाई सम्पर्क गर्नुहोस्।",
  },
};
export default ne;
